import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface OrderReportCommand {
  fromDate: Date;
  toDate: Date;
}

@Injectable({
  providedIn: 'root',
})
export class OrderReportProxyService {
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/reports';

  constructor(private http: HttpClient) {}

  public yarnImportReport(command: OrderReportCommand, includeCosts: boolean, typeStandard: boolean): Observable<Blob> {
    //include costs and type standard are query params, while  the command is sent in the body
    const params = {
      includeCosts: includeCosts.toString(),
      typeStandard: typeStandard.toString(),
    };
    return this.http.post(`${this.baseUrl}/excel/invoices/yarn-purchase-report`, command, { params, responseType: 'blob' });
  }
}
